import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Alert } from '../../shared/components/DiComponents';

export default function SchedulingApptUnavailableWarning() {
  return (
    <Alert type="warning" p="md" my="md">
      <FormattedMessage
        id="scheduling.SchedulingApptHasPassed.appointmentPassed"
        defaultMessage="Please select another time."
      />
    </Alert>
  );
}
